/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { EventMessage, EventType, LogLevel, PublicClientApplication, Configuration, RedirectRequest } from '@azure/msal-browser';
import { RootStore } from "../src/stores";
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID as string,
    authority: process.env.REACT_APP_AZURE_AUTHORITY as string,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: "/"
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            console.warn(message);
        }
      },
    },
  },
};
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

export const tokenRequest: RedirectRequest = {
  scopes: ["api://" + process.env.REACT_APP_AZURE_CLIENT_ID + "/ApplicationScope"]
};

export const loginRequest: RedirectRequest = {
  scopes: ["openid", "profile", "User.Read" ]
};


export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.addEventCallback((eventMessage: EventMessage) => {
  if (eventMessage.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    msalInstance.loginRedirect(loginRequest);
  }

  if (eventMessage.eventType === EventType.LOGIN_SUCCESS || eventMessage.eventType === EventType.HANDLE_REDIRECT_END) {
    const activeAccount = msalInstance.getActiveAccount();
    if (!activeAccount) {
      const availableAccounts = msalInstance.getAllAccounts();
      console.log("Account Found:", availableAccounts.length)
      if (availableAccounts.length > 0) {
        console.log("No Active Account Found, Setting first, Fetching User Profile!");
        msalInstance.setActiveAccount(availableAccounts[0])
        RootStore.userProfileStore.fetchUserProfile();
      }
    } else {
      console.log("Active Account Found, Fetching User Profile!");
      RootStore.userProfileStore.fetchUserProfile();
    }
  }
});

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  myProfileEndpoint: "https://graph.microsoft.com/v1.0/me",
  myPhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};